import { useMedia } from 'react-use';
import { mq } from 'styles/sizes';
import { ValueOf } from 'type-fest';

// accepts media query from "mq" values like "mq.sm"
// returns whether this media query matches
export const useThemeMedia = (mediaQuery: ValueOf<typeof mq>) => {
  return useMedia(mediaQuery.replace('@media ', ''));
};
